/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type FormContainerProps = {
    children: React.ReactNode | React.ReactNode[]
    className?: string
}

const UiFormContainer: React.FC<FormContainerProps> = ({
    children,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiFormContainer ',
				className,
				'w-full h-full min-h-0 flex flex-col overflow-hidden',
            )}
        >
            {children}
        </div>
    )
}

export default UiFormContainer
